import dates from 'src/utils/dates'

const GETTERS = {
  humans(state, getters, rootState, rootGetters) {
    const persons = rootGetters['tools/persons']

    return persons.map((person) => {
      const { personNameFirst, personNameLast } = person
      const fullName = `${personNameFirst} ${personNameLast}`

      return {
        ...person,
        operator: 'incl',
        text: fullName,
        value: fullName,
      }
    })
  },

  internals(state, getters) {
    const { humans } = getters

    return humans.filter((human) => {
      const { access = {} } = human

      return access.role === 'internal'
    })
  },
  delegates(state, getters, rootState) {
    const { humans } = getters
    const { auth: { user } } = rootState

    if (!humans || !user) return []

    const { access: { level, role }, personId: userId } = user
    const isAdminUser = role === 'internal' && level === 'admin'

    if (isAdminUser) return humans

    return humans.reduce((delegates, person) => {
      const self = person.personId === userId
      const isManager = person.managerPersonId === userId

      if (self || isManager) {
        const { personId, personNameFirst, personNameLast } = person
        const fullName = `${personNameFirst} ${personNameLast}`

        delegates.push({
          ...person,
          operator: 'incl',
          text: fullName,
          value: personId,
        })
      }

      return delegates
    }, [])
  },

  minCalendarDate() {
    return dates.getStartOfMonth()
  },
  maxCalendarDate() {
    return dates.getEndOfMonth()
  },
  successMessage(state) {
    const { action } = state

    if (action === 'create') return 'Added'
    if (action === 'update') return 'Edited'
    if (action === 'delete') return 'Deleted'

    return 'Success'
  },
  errorMessage(state) {
    const { action } = state

    if (action === 'create') return 'Failed to Add. Please try again.'
    if (action === 'update') return 'Failed to Edit. Please try again.'
    if (action === 'delete') return 'Failed to Delete. Please try again.'

    return 'Error'
  },
}

export default GETTERS
